import { useState } from 'react';
import instance from '@src/api/axiosInstance';
import { logger } from '@src/utils/misc/logger';

interface LoadShareResponse {
  copied_session_id: string;
  status: string;
}

export const useLoadShare = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const loadShare = async (shareId: string, newSessionId: string) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const response = await instance.post<LoadShareResponse>('/nexa/share/load', {
        share_id: shareId,
        new_session_id: newSessionId,
      });

      setSuccess(true);
      logger.log('Share loaded successfully', {
        share_id: shareId,
        new_session_id: newSessionId,
      });
      return response.data;
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Failed to load shared session';
      setError(errorMessage);
      logger.error('Failed to load share', err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return { loadShare, loading, error, success };
};
